
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warenkorb",
      function () {
        return require("private-next-pages/warenkorb.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warenkorb"])
      });
    }
  